// import PropTypes from "prop-types";
import { Typography as MuiTypography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';

const Typography = ({
  token,
  text,
  color,
  textAlign = 'center',
  cursor = 'default',
  redirect = undefined,
  style = {},
  handleClick,
  copyToClipboard = false
}) => {
  const navigate = useNavigate();

  return (
    <MuiTypography
      {...token}
      color={color}
      textAlign={textAlign}
      sx={{
        cursor,
        ...(cursor === 'pointer' && {
          textDecoration: 'underline',
          textUnderlinePosition: 'from-font'
        }),
        ...style
      }}
      onClick={() => {
        redirect && navigate(redirect);
        handleClick && handleClick();
      }}
    >
      {copyToClipboard ? (
        <CopyToClipboard
          text={text}
          onCopy={() => {
            toast.success('Copied to clipboard');
          }}
        >
          <span>{text}</span>
        </CopyToClipboard>
      ) : (
        text
      )}
    </MuiTypography>
  );
};

// Typography.PropTypes = {
//   text: PropTypes.string.isRequired,
//   token: PropTypes.exact({
//     fontFamily: PropTypes.string,
//     fontSize: PropTypes.string,
//     fontWeight: PropTypes.string,
//     lineHeight: PropTypes.string,
//   }).isRequired,
//   color: PropTypes.string.isRequired,
//   redirect: PropTypes.string,
//   handleClick: PropTypes.func,
//   cursor: PropTypes.oneOf(["default", "pointer"]),
//   style: PropTypes.object,
// };

export default Typography;
